
import React, {useEffect} from "react";
import {CounterBgDay} from "../SVG/CounterBgDay";
import {gsap} from "gsap";


const ShowCounter: React.FC<{
    days: number,
    hours: number,
    minutes: number,
    seconds: number
}> =  ({ days, hours, minutes, seconds }) => {

    useEffect(() => {
        gsap.fromTo(
            `.gf`,
            {
                position: "relative",
               transform: "rotateY(0deg)",
                opacity: .9
            },
            {
                duration: 1,
                ease: "none",
                transform: "rotateX(360deg)",
                opacity: 1,
                scrollTrigger: {
                    trigger: `.t3`,
                    start: "top center-=100",
                    end: "center center+=100",
                    // markers: true,
                    scrub: 1,
                    toggleActions: "restart none reverse reset",
                },
            }
        );
    gsap.fromTo(
            `.counters`,
            {
                position: "relative",
              bottom: "-100px",
                opacity: .5
            },
            {
                duration: 1,
                ease: "none",
                bottom: "0px",
                opacity: 1,
                scrollTrigger: {
                    trigger: `.t3`,
                    start: "top center-=100",
                    end: "center center+=100",
                    // markers: true,
                    scrub: 1,
                    toggleActions: "restart none reverse reset",
                },
            }
        );
    }, []);


    return (
        <div className="show-counter">
            <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                className="countdown-link"
            >
                <div className="counter__flex">
                    <div className="counter__counter counters">
                        <CounterBgDay width="auto" />
                        <div className="counter__counter__count">
                            <div className="counter__number gf">{days}</div>
                            <div className="counter__text">days</div>
                        </div>
                    </div>
                    <div className="counter__counter counters">
                        <div style={{transform: "rotateX(180deg) rotateY(180deg) translateX(-7px)"}}>
                            <CounterBgDay  width="auto" />
                        </div>
                        <div className="counter__counter__count" style={{margin: 0}}>
                            <div className="counter__number gf">{hours}</div>
                            <div className="counter__text">hours</div>
                        </div>
                    </div>
                    <div className="counter__counter counters">
                        <div style={{transform: "rotateX(180deg)"}}>
                            <CounterBgDay  width="auto" />
                        </div>
                        <div className="counter__counter__count">
                            <div className="counter__number gf">{minutes}</div>
                            <div className="counter__text">minutes</div>
                        </div>
                    </div>
                    <div className="counter__counter counters">
                        <div style={{}}>
                            <CounterBgDay  width="auto" />
                        </div>
                        <div className="counter__counter__count">
                            <div className="counter__number gf">{seconds}</div>
                            <div className="counter__text ">seconds</div>
                        </div>
                    </div>
                </div>
            </a>
        </div>
    );
};
export default ShowCounter;